import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loading from '../../component/common/loading/Loading';

import { useDynamicStyle } from '../../hooks/useDynamicStyle';
import { EmptyDalgu } from '../../images/icons/icons_component';
import { decodeHtmlEntities } from '../../utils/htmlEntity.js';

const HomeBoard = ({boardNo}) => {

    const navigate = useNavigate();

    const dataHead = ['번호', '제목', '날짜']; //component화 
    const dataColumn = ['RNUM', 'NTT_TIL', 'REGDAY'];

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    });

    const getDataList = async () => {
        setState(prev => ({
            ...prev,
            isLoading: true
        }));
        try {
            const response = await axios.get('/commonapi/selectMainBoardContents.do',
                { params: {boardNo : boardNo} }
            );
            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true,
                isLoading: false
            }));
        } catch (error) {
            console.error('게시판 데이터 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        getDataList();
    }, []);

    // Dynamic Style Hook
    const { lightBackColor, hoverFontColor } = useDynamicStyle();

    return (
        <div className='data_grid_container'>
            {state.isLoading ? <Loading /> :
                <div className='data_list_table'>
                    <table>
                        <thead>
                            <tr>
                                {dataHead.map((content, index) => (
                                    <th key={index}>
                                        {content}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {!state.dataList || state.dataList.length === 0 ? (
                                <tr>
                                    <td colSpan={dataHead.length+1}>
                                        <span className={`data_empty ${lightBackColor}`}>
                                            <EmptyDalgu/>해당하는 데이터가 없습니다.
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                state.dataList.map((item, index) => {
                                const gridColor = index % 2 === 0 ? lightBackColor : '';
                                return (
                                    <tr key={index} className={gridColor + ' ' + hoverFontColor}>
                                        {dataColumn.map((idx, colIdx) => {
                                            return ( colIdx === 1 ?
                                                <td key={colIdx} className='cursor-pointer'>
                                                    <div role='link' tabIndex={0}
                                                        onClick={() => navigate(`${item.MENUSORC}/${item.NTT_SNO}`)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                navigate(`${item.MENUSORC}/${item.NTT_SNO}`);
                                                            }
                                                        }}>
                                                            {decodeHtmlEntities(item[idx])}
                                                    </div>
                                                </td>
                                                : <td key={colIdx}>{decodeHtmlEntities(item[idx])}</td>
                                            )
                                        })}
                                    </tr>
                                )})
                            )}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}

export default HomeBoard